import {SurchargeTimeDefinitionList} from "./SurchargeTimeDefinitionList.tsx";
import {FormDialog} from "./FormDialog.tsx";

export const SurchargeDefinitionPage = () => {

    return <>
        <FormDialog/>
        <h1>Surcharge Definitions</h1>
        <SurchargeTimeDefinitionList/>
    </>
}